import React from 'react'
import styles from './styles.css'
import {Link} from 'react-router'

export default class Logo extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div>
        <div className={styles.logo}>
          <Link to="/">
            <img src="/logo-black.svg" alt="logo" />
          </Link>
          <div>Pay</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/Logo/index.js